import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TimeSigControl = ({ beatsPerMeasure, onTimeSigChange }) => {
  const { t } = useLanguage();

  const timeSignatures = [1, 2, 3, 4, 5, 6];

  return (
    <div className="text-center">
      <label className="block text-lg font-semibold mb-4 text-gray-700 dark:text-gray-300">
        📊 {t('beatsPerMeasure')}
      </label>
      <div className="flex justify-center space-x-2 flex-wrap">
        {timeSignatures.map(beats => (
          <button
            key={beats}
            onClick={() => onTimeSigChange(beats)}
            className={`w-12 h-12 rounded-xl font-bold transition-all duration-200 ${
              beatsPerMeasure === beats
                ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg text-xl'
                : 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-gray-500 text-lg'
            }`}
          >
            {beats}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TimeSigControl;